import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import { REM_CONFIG } from "@/utils/fontSize";
const RevenueProportion = ({ className = "", data, }) => {
    // 模拟接口返回的默认数据（后期可直接替换为接口请求结果）
    const defaultData = [
        { name: "神木", value: 35 },
        { name: "榆林", value: 25 },
        { name: "新疆", value: 20 },
        { name: "包头", value: 20 },
    ];
    // 优先使用传入的接口数据，无数据时使用默认模拟数据
    const chartData = data || defaultData;
    // 提取名称列表用于图例（动态从数据中获取，避免硬编码）
    const legendNames = chartData.map((item) => item.name);
    // 构建 ECharts 配置项
    const option = {
        tooltip: {
            show: true,
            trigger: "item",
            // 格式化tooltip显示内容，支持显示百分比（补充“万元”单位）
            formatter: "{a} <br/>{b}: {c} 万元 ({d}%)",
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: {
                color: "#fff",
            },
        },
        color: ["#467BD8", "#73C7EF", "#89D37F", "#FFFFFF"],
        legend: {
            orient: "vertical",
            right: 20,
            itemGap: 20,
            top: "28%",
            textStyle: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small },
            data: legendNames, // 动态使用数据中的名称
        },
        series: [
            {
                name: "收入占比", // 用于tooltip显示
                type: "pie",
                radius: ["50%", "70%"],
                center: ["35%", "50%"],
                label: { show: false },
                emphasis: {
                    // 鼠标 hover 时显示数值+单位
                    label: {
                        show: true,
                        color: "#FFFFFF",
                        fontSize: REM_CONFIG.fontSize.small,
                        formatter: "{c} 万元",
                    },
                },
                data: chartData, // 使用标准化的接口数据格式
                labelLine: { show: false },
                percentPrecision: 1, // 百分比保留1位小数
            },
        ],
    };
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
        flex flex-col 
        ${className}
        min-h-0
      `, children: [_jsx(ModuleHeader, { title: "\u5206\u9879\u6536\u5165\u5360\u6BD4" }), _jsxs("div", { className: "flex-1 min-h-0 relative", children: [_jsx("div", { style: {
                            position: "absolute",
                            top: "16px", // 距离顶部距离，可按需调整
                            right: "5px",
                            color: "#FFFFFF",
                            fontWeight: 500,
                            zIndex: 10, // 确保层级高于图表，避免被覆盖
                            backgroundColor: "rgba(6, 32, 66, 0.6)", // 半透明背景，提升可读性
                            padding: "4px 8px",
                            borderRadius: 4,
                            fontSize: REM_CONFIG.fontSize.small,
                        }, children: "\u5355\u4F4D\uFF08\u4E07\u5143\uFF09" }), _jsx(ReactEcharts, { option: option, style: { width: "100%", height: "100%" } })] })] }));
};
export default RevenueProportion;
